const DEFAULT_WHATSAPP_MESSAGE = 'Merhaba, turlarınız hakkında bilgi almak istiyorum.'
const WHATSAPP_CODE_PATTERN = /^(?:[A-Z0-9]{6}|\d{5})$/i
const WHATSAPP_CODE_AT_END_PATTERN = /\s*#(?:[A-Z0-9]{6}|\d{5})\s*$/i

export const isWhatsAppUrl = (value: string) => {
  try {
    const url = new URL(value, 'https://inanctur.com.tr')
    const host = url.hostname.toLowerCase().replace(/^www\./, '')
    return host === 'wa.me' || host === 'whatsapp.com' || host.endsWith('.whatsapp.com')
  } catch {
    return false
  }
}

export const hasWhatsAppRecipient = (value: string) => {
  try {
    const url = new URL(value, 'https://inanctur.com.tr')
    const host = url.hostname.toLowerCase().replace(/^www\./, '')
    const phone = host === 'wa.me'
      ? url.pathname.split('/').filter(Boolean)[0]
      : url.searchParams.get('phone')
    return String(phone || '').replace(/\D/g, '').length >= 8
  } catch {
    return false
  }
}

export const appendWhatsAppTrackingCode = (value: string, code: string) => {
  const normalizedCode = String(code || '').trim().toUpperCase()
  if (!WHATSAPP_CODE_PATTERN.test(normalizedCode)) return value

  try {
    const url = new URL(value, 'https://inanctur.com.tr')
    const currentText = (url.searchParams.get('text') || DEFAULT_WHATSAPP_MESSAGE)
      .replace(WHATSAPP_CODE_AT_END_PATTERN, '')
      .trimEnd()
    url.searchParams.set('text', `${currentText}\n#${normalizedCode}`)
    return url.toString()
  } catch {
    return value
  }
}
